import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';

import { AppDispatch, RootState } from 'interfaces';

import Layout from 'components/Layout';
import ConcertDetailsComponent from 'components/ConcertDetails';
import StatisticSideBar from 'components/StatisticSideBar';

import Loader from 'components/ui/Loader';

import { getAllShows, getMostPlayedAlbums } from 'features/statistics/statisticsSlice';

import { getConcertDetails } from './toursSlice';

const ConcertDetails = () => {
  const { concertId } = useParams();

  const dispatch = useDispatch<AppDispatch>();

  useEffect(() => {
    dispatch(getConcertDetails({ concertId }));
  }, [dispatch, concertId]);

  const concertDetails = useSelector((state: RootState) => state.tours.concertDetails);
  const tourDetails = useSelector((state: RootState) => state.tours.tourDetails);
  const setList = useSelector((state: RootState) => state.tours.setList);

  useEffect(() => {
    dispatch(getAllShows({ tourId: tourDetails?.id || null, limitYear: concertDetails?.date?.split('-')?.[0] || null }));
    dispatch(getMostPlayedAlbums({ tourId: tourDetails?.id || null, limit: 5, limitYear: concertDetails?.date?.split('-')?.[0] || null  }));
  }, [dispatch, tourDetails, concertDetails]);

  const allShows = useSelector((state: RootState) => state.statistics.allShows);
  const mostPlayedAlbums = useSelector((state: RootState) => state.statistics.mostPlayedAlbums);

  return concertDetails ? (
      <Layout sidebar={(
        <StatisticSideBar
          context={tourDetails?.id ? 'concert' : 'year'}
          allShows={allShows}
          mostPlayedAlbums={mostPlayedAlbums}
        />
      )}>
      <ConcertDetailsComponent
        tour={tourDetails}
        concert={concertDetails}
        setList={setList}
      />
      </Layout>
  ) : <Loader />;
};

export default ConcertDetails;
